export const ICONS_ID = 'icons-root';

/** Icon sizes based on sizing framework taxonomy
 * https://design-system.protontech.ch/?path=/docs/css-utilities-sizing--fractions#framework */
export const ICON_PX_SIZES = [10, 11, 12, 14, 16, 18, 20, 22, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60];
